(function(){
    'use strict';

    angular.module('app').component('publicNewsItems', {
        bindings: {
            appName: '@',
            languageCode: '@',
            onReady: '&?'
        },
        template: '<news-items on-ready="$ctrl.onReady()" mode="public" searchable="false" collapsible="false" app-name="{{$ctrl.appName}}" language-code="{{$ctrl.languageCode}}" types="news"></news-items>'
    });
})();